var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrap"},[_c('img',{staticClass:"icon-empty",attrs:{"src":_vm.emptyIcon,"alt":""}}),_c('p',{staticClass:"empty-title"},[_vm._v(_vm._s(_vm.emptyTitle || _vm.$t('message.tableCommon.notFoundInfo')))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }